module.exports = __webpack_public_path__ + "img/img_fabuchanping.dc810c17.png";